// extracted by mini-css-extract-plugin
export default {"Box":"iteration-renderer-module__Box--UAdz1","Label":"iteration-renderer-module__Label--IBs87"};